module.exports = __webpack_public_path__ + "media/US_ringback_tone.7ce9c950.ogg";